import React from 'react';

const Ico = () => {
    return (
            <svg  width="18" height="14" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0.5 13.99L11.5 14C12.17 14 12.77 13.67 13.13 13.16L17.5 7L13.13 0.84C12.77 0.33 12.17 0 11.5 0L0.5 0.0100002L5.34 7L0.5 13.99Z" fill="#73FFFF"/>
            </svg>
    );
};

export default Ico;